// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vxa72","footerLink":"Footer_footerLink__0G+jQ","copyright":"Footer_copyright__Bd-rs","helpText":"Footer_helpText__DmS-2"};